function isWorkletFunction(value) {
  return typeof value === "function" && !!value.__workletHash;
}
function runOnUISync(worklet) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return worklet(...args);
}
export {
  isWorkletFunction,
  runOnUISync
};
//# sourceMappingURL=react-native-worklets.js.map
